import * as React from 'react';
import api from '../../../services/api';
import {
  Paper,
  Button,
  Box,
  Container,
  FormControl,
  Stack,
  DialogContentText,
  Divider
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useStoreActions } from 'easy-peasy';
import TextField from '../../../components/TextField';
import FloatField from '../../../components/FloatField';
import yupnanable from '../../../services/yup-nanable.js';

const DadosGerais = ({ ano, watchEmpresaId }) => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);

  const schema = yup
    .object({
      faturamentoBrutoReal: yup
        .number()
        .nullable()
        .positive()
        .float()
        .nanable()
        .label('Faturamento Bruto em Real (R$)'),
      faturamentoBrutoDolar: yup
        .number()
        .nullable()
        .positive()
        .float()
        .nanable()
        .label('Faturamento Bruto em Dólar ($)'),
      capitalSocial: yup
        .number()
        .nullable()
        .positive()
        .float()
        .nanable()
        .label('Capital Social (R$)'),
      observacoes: yup.string().nullable().max(1000, 'Máximo 1000 caracteres').label('Observações')
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const onSave = async data => {
    startLoading();
    let result;
    try {
      if (data.id) {
        result = await api.http.put(
          `/00/dados-gerais/empresa/${watchEmpresaId}/${data.id}`,
          {
            ...data,
            ano
          }
        );
      } else {
        result = await api.http.post(
          `/00/dados-gerais/empresa/${watchEmpresaId}`,
          {
            ...data,
            ano
          }
        );
      }
      reset(result.data);
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const loadDadosGerais = async mount => {
    startLoading();
    try {
      let getDadosGeais = await api.http.get(
        `/00/dados-gerais/empresa/${watchEmpresaId}/${ano}`
      );
      if (mount.isMounted) {
        reset(getDadosGeais.data);
      }
      stopLoading();
    } catch (error) {
      if (error.response && error.response.status == 404) {
        if (mount.isMounted) {
          reset({
            faturamentoBrutoReal: '',
            faturamentoBrutoDolar: '',
            capitalSocial: '',
            observacoes: ''
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadDadosGerais(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [watchEmpresaId, ano]);

  return (
    <div>
      <Divider>
        <h3>Dados Gerais</h3>
      </Divider>
      <Stack direction="row" sx={{ textAlign: 'center' }}>
        <p>
          Durante o ano de referência, qual foi o faturamento bruto da sua
          empresa ?
        </p>
      </Stack>
      <Stack direction="row" sx={{ textAlign: 'center' }}>
        <FormControl sx={{ width: 300 }}>
          <FloatField
            field="faturamentoBrutoReal"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
        <Box sx={{ py: 2 }}>OU</Box>
        <FormControl sx={{ width: 300 }}>
          <FloatField
            field="faturamentoBrutoDolar"
            schema={schema}
            useFormRef={useFormRef}
          />
        </FormControl>
      </Stack>
      <Stack direction="row">
        <p>
          Durante o ano referência, qual foi o valor do capital social da sua
          empresa ?
        </p>
      </Stack>
      <FormControl sx={{ my: 1 }} fullWidth>
        <FloatField
          sx={{ width: 300 }}
          field="capitalSocial"
          schema={schema}
          useFormRef={useFormRef}
        />
      </FormControl>
      <Stack direction="row">
        <p>
          Deixe seu comentário ou outras informações que considerar importante:
        </p>
      </Stack>
      <FormControl sx={{ y: 1, mb: 3 }} fullWidth>
        <TextField
          field="observacoes"
          type="text"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <DialogContentText>Importante!</DialogContentText>
      <DialogContentText>
        Os campos com valores em Reais (R$) devem ser preenchidos com o valor
        completo em R$.
      </DialogContentText>
      <DialogContentText>
        Não utilize a escala de milhões (M) de Reais.
      </DialogContentText>
      <Button
        variant="outlined"
        sx={{ mr: 2 }}
        onClick={() => {
          reset();
        }}
        disabled={!isDirty || isSubmitting}
      >
        CANCELAR
      </Button>
      <Button
        sx={{ my: 2 }}
        variant="contained"
        onClick={handleSubmit(onSave)}
        disabled={!isDirty || isSubmitting}
      >
        Salvar
      </Button>
    </div>
  );
};

export default DadosGerais;
